import { ALL_SESSION_STATUS_DISPLAYS } from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-display';
import { type CoachingSessionStatus } from '@efdigital/ll-addon-data';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

interface SelectSessionStatusCheckboxListSignature {
  Args: {
    values: CoachingSessionStatus[];
    onChange: (value: CoachingSessionStatus[]) => void;
    itemClass?: string;
  };
  Element: HTMLDivElement;
}

export class SelectSessionStatusCheckboxList extends Component<SelectSessionStatusCheckboxListSignature> {
  isSelected = (status: string) => {
    return this.args.values.includes(status as CoachingSessionStatus);
  };

  onChange = (event: Event) => {
    const status = (event.target as HTMLInputElement).value;
    if (this.isSelected(status)) {
      this.args.onChange(this.args.values.filter((value) => value !== status));
    } else {
      this.args.onChange([
        ...this.args.values,
        status as CoachingSessionStatus,
      ]);
    }
  };

  <template>
    <div ...attributes>
      {{#let (uniqueId) as |id|}}
        {{#each ALL_SESSION_STATUS_DISPLAYS as |item|}}
          <div class={{@itemClass}}>
            <div class="form-check">
              <input
                id="{{id}}-{{item.status}}"
                class="form-check-input"
                type="checkbox"
                value={{item.status}}
                checked={{this.isSelected item.status}}
                {{on "change" this.onChange}}
              />
              <label for="{{id}}-{{item.status}}" class="form-check-label">
                {{item.display.uniqueLabel}}
                <iconify-icon
                  class="text-{{item.display.color}}"
                  icon={{item.display.icon}}
                  inline
                  aria-hidden="true"
                /></label>
              <p class="form-text mt-0">{{item.display.adminDescription}}</p>
            </div>
          </div>
        {{/each}}
      {{/let}}
    </div>
  </template>
}
